import { useAccessTier } from "@/hooks/useAccessTier";

/**
 * Parent Dashboard scope. HeirWise is a paid product with a single
 * production experience, so every entitled account gets the full scope.
 * Retained as a hook so surfaces keep one place to branch if a reduced
 * scope is ever reintroduced for a legitimate product reason.
 */
export type DashboardScope = "full";

export function useDashboardScope(): { scope: DashboardScope; isAdmin: boolean; loading: boolean } {
  const { tier, loading } = useAccessTier();
  return { scope: "full", isAdmin: tier === "admin", loading };
}

/** Core readiness dimensions surfaced first on the Parent Dashboard. */
export const PRIMARY_DIMENSION_IDS = new Set(["money", "credit", "decision", "scam"]);

/** Advanced readiness dimensions grouped after the core set. */
export const ADVANCED_DIMENSION_IDS = new Set(["investing", "entrepreneurship"]);
